module.exports = __webpack_public_path__ + "static/school-bus-pass-renewal-894214409c5664ae757b640208e8c55f.jpg";